// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "container-3faHj";
var _3 = "html-27eQv";
var _4 = "reject-3X1aP";
var _5 = "notice-1hB0Y";
var _6 = "error-2QseA";
var _7 = "time-2rvtV";
export { _1 as "__esModule", _2 as "container", _3 as "html", _4 as "reject", _5 as "notice", _6 as "error", _7 as "time" }
export default { "__esModule": _1, "container": _2, "html": _3, "reject": _4, "notice": _5, "error": _6, "time": _7 }
